'use client';

import { useAppSelector } from '@/app/lib/store/hooks';
import LogoLink from './logo-link';

interface Props {
  logoHeight: number;
}

export default function LogoContainer({ logoHeight }: Props) {
  const theme = useAppSelector(state => state.theme.mode);

  return (
    <LogoLink
      theme={theme}
      height={logoHeight}
    />
  );
}
